export const Logo = ({ size = 40 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <rect x="10" y="10" width="80" height="80" stroke="#FFFFFF" strokeWidth="8" fill="none" />
        <path d="M10 50H90" stroke="#FF6A00" strokeWidth="6" />
        <circle cx="50" cy="50" r="16" stroke="#FFFFFF" strokeWidth="6" fill="none" />
        <path d="M50 10V90" stroke="#FFFFFF" strokeWidth="4" strokeDasharray="6 6" />
        <rect x="70" y="70" width="20" height="20" fill="#FF6A00" />
    </svg>
);
